import React from 'react';
import PropTypes from 'prop-types';

import { withPubNubCtx } from './PubNubContext';

/**
 * Lightweight wrapper around the context consumer to handle setup/cleanup for
 * PubNub subscribers. `subscribe` and `unsubscribe` are passed via HOC.
 */
export class PubNubSubscribe extends React.Component {
  static propTypes = {
    channels: PropTypes.arrayOf(PropTypes.string).isRequired,
    onMessage: PropTypes.func.isRequired,
    subscribe: PropTypes.func,
    unsubscribe: PropTypes.func,
  };

  static defaultProps = {
    subscribe: () => {},
    unsubscribe: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      subscription: {},
    };
  }

  // This breaks tests if renamed
  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    const { channels, onMessage, subscribe } = this.props;
    subscribe({
      channels,
      onMessage,
      onSubscribe: subscription => {
        this.setState({ subscription });
      },
    });
  }

  componentWillUnmount() {
    const { unsubscribe } = this.props;
    const { subscription } = this.state;
    unsubscribe(subscription);
  }

  render() {
    return null;
  }
}

export default withPubNubCtx(PubNubSubscribe);
